import React from "react";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";

export default function PartnershipOpportunities() {
  return (
    <StandardLayout
      main={
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdI4yIWcbnTwZrlIt_mN4G3qLnx5HfptdHGV4k8gubuoC7qoA/viewform?embedded=true"
          width="776"
          height="1473"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
        >
          Loading…
        </iframe>
      }
      complementary={<LatestStories />}
      mainAriaLabel="Partnership Opportunities"
    />
  );
}
